import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { map } from 'rxjs/operators';
import { AppConfig } from '../../app.config';
import { HasPermissionService, NotificationService } from '../services/service.index';
import { LoginResponseModel } from '../../main/authentication/authentication.model';
import { CookieService } from 'ngx-cookie-service';
import { CompanySecuritycodeComponent } from '../component/global-company/company-securitycode/company-securitycode.component';
import { GlobalCompanyService } from '../component/global-company/global-company.service';
import { FuseAlertService } from '@fuse/components/alert';

@Injectable()
export class AuthGuard implements CanActivate {
  notificationService: NotificationService;
  loginResponse: LoginResponseModel;
  /**Dialog Ref variables**/
  dialogRef: any;

  constructor(private router: Router,
    @Inject(PLATFORM_ID) private platformId: any,
    private readonly appConfig: AppConfig,
    private matDialog: MatDialog,
    private snb: MatSnackBar,
    public fuseAlertService: FuseAlertService,
    private cookieService: CookieService,
    private globalCompanyService: GlobalCompanyService,
    private _hasPermissionService: HasPermissionService
  ) {
    this.notificationService = new NotificationService(snb);
    this.loginResponse = new LoginResponseModel();
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if (this.appConfig.isAuthenticated()) {
      return true;
      //if (this.cookieService.check("RiskSelectedCompany")) {
      //  let riskSelectedCompany = JSON.parse(this.cookieService.get("RiskSelectedCompany"));
      //  this.loginResponse.SelectedCompany = riskSelectedCompany;
      //}
      //this.loginResponse.Response = this.appConfig.getCurrentUser();
      //if (this.loginResponse.Response.isCompanyMoreThenOne) {
      //  /*Get User Company List*/
      //  return this.checkSelectedCompanyCodeVerify();
      //} else {
      //  return true;
      //}
    } else {
      this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }
  }

  checkSelectedCompanyCodeVerify() {
    /* Check User is SystemPowerAdmin or SystemAdmin*/
    if (this.loginResponse.Response.isSpaOrSa) {
      /*Check Security Code Enabled*/
      if (this.loginResponse.Response.isSecurityCodeEnabled) {
        return this.selectedCompanyCodeVerify();
      } else {
        return this.selectedCompanyCodeVerify();
      }
    } else {
      return this.selectedCompanyCodeVerify();
    }

  }

  selectedCompanyCodeVerify() {
    if (this.loginResponse.SelectedCompany != null || this.loginResponse.SelectedCompany != undefined) {
      if (this.loginResponse.SelectedCompany.userId == this.loginResponse.Response.userId) {
        if (!this.loginResponse.SelectedCompany.isCompanyCodeVerify) {
          return this.reVerifyCompanyCode();
        } else {
          return true;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  reVerifyCompanyCode() {
    let isValidCode = false;
    this.dialogRef = this.matDialog.open(CompanySecuritycodeComponent, {
      width: '450px',
      panelClass: "company-security-code",
      data: this.loginResponse.SelectedCompany
    });

    this.dialogRef.afterClosed().subscribe(response => {
      if (!response) {
      }
      const actionType: string = response[0];
      const isCompanyCodeVerify: boolean = response[1];
      this.loginResponse.SelectedCompany.isCompanyCodeVerify = isCompanyCodeVerify;
      switch (actionType) {
        case 'submit': {
          this.afterCompanyChangeProcess(this.loginResponse.SelectedCompany, true, isCompanyCodeVerify);
          let message = `Company code is ${isCompanyCodeVerify ? '' : 'not '}verifyed.`;
          //this.notificationService.showNotification(message);
          this.fuseAlertService.show(message, 2);
          isValidCode = isCompanyCodeVerify;
          break;
        }
        case 'exit':
          this.afterCompanyChangeProcess(this.loginResponse.SelectedCompany, true, false);
          isValidCode = false;
          break;
        default:
          this.afterCompanyChangeProcess(this.loginResponse.SelectedCompany, true, false);
          this.fuseAlertService.show("Company code is not verifyed.", 0);
          //this.notificationService.showNotification("Company code is not verifyed.");
          isValidCode = false;
          break;
      }

      return isValidCode;
    });
  }

  afterCompanyChangeProcess(model, isNeedVerify: boolean, isCompanyCodeVerify: boolean) {
    if (isNeedVerify) {
      if (!isCompanyCodeVerify) {
        this.globalCompanyService.globalCompany.subscribe(res => {
          if (res === 0) {
            return;
           // this.fuseAlertService.show(res.message, res.status);
          } else {
            const selectedCompany = this.globalCompanyService.assignedCompanyList.value.find(x => x.companyId === res);

            model = {
              userId: this.appConfig.getCurrentUserId(),
              companyId: selectedCompany.companyId,
              companyName: selectedCompany.companyName,
              isSecurityCodeAvailable: selectedCompany.isSecurityCodeAvailable,
              isCompanyCodeVerify: true
            };
          }
        });
      } else {
        this.globalCompanyService.globalParentAssessment = 0;
        this.globalCompanyService.globalCompany = model.companyId;
      }
    } else {
      this.globalCompanyService.globalParentAssessment = 0;
      this.globalCompanyService.globalCompany = model.companyId;
    }

    var todayDate = new Date();
    todayDate.setDate(todayDate.getDate() + 365);

    this.cookieService.delete('RiskSelectedCompany', "/");
    this.cookieService.set('RiskSelectedCompany', JSON.stringify(model), todayDate, "/");
  }
}

/**Ami: Role based Permsion Can Activate**/
@Injectable()
export class HasPermissionGuardService implements CanActivate {


  constructor(private router: Router,
    @Inject(PLATFORM_ID) private platformId: any,
    private readonly appConfig: AppConfig,
    private readonly hasPermissionService: HasPermissionService
  ) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let url = state.url.slice(1);
    if (this.appConfig.isAuthenticated()) {
      if (this.hasPermissionService.isApiCallCompleted) {
        var objHasPermission = this.hasPermissionService.isPermission(url, true);
        if (objHasPermission) {
          return true;
        } else {
          /**
           * If current Url is for assessment dashboard and user don't have permission
           * Redirect to client user dash board page*
           */
          var isDashbardRequest = url.includes("main/dashboard");
          if (isDashbardRequest) { // Redirect to client user  dashboard for client user and bs experts if dont have permissions for assessment dashboard
            this.router.navigate(['/main/dashboard/client-user']);
            return true;
          } else {
            this.router.navigate(['/errors/error-forbidden']);
            return false;
          }
        }
      }
      return this.hasPermissionService.getUserPermissionObservable(url, true).pipe(
        map((res) => {
          if (res) {
            return true;
          } var isDashbardRequest = url.includes("main/dashboard");
          if (isDashbardRequest) { // Redirect to dashboard 2 for client user and bs experts if dashboard request and no permissions
            this.router.navigate(['/main/dashboard/client-user']);
            return true;
          } else {
            this.router.navigate(['/errors/error-forbidden']);
            return false;
          }
        }));
    } else {
      this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }

  }


}
